module.exports = __webpack_public_path__ + "static/media/Shox 02.454a7e0a.png";